import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { store } from "../../../testStore";
import { TextInput } from '../../../lib/components/textInput';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* Json */
import { parse, parseArray, safeDeepGet, safeDeepGetWithType } from 'iotera-base/json'
import { isEmpty } from 'iotera-base/object';

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Actions */
import { buildWBoundActions } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

import { setDeviceUSRIotPayload } from '../../../testActions';
import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { setDeviceEmpty } from '../../../testActions';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const CHECK_DEV_UID = 'CHECK_DEV_UID';
const SUBMIT_DEVICE = 'SUBMIT_DEVICE';
const WKEY = "DEVICE_ACTIVATION";
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

function schema() {
  return {
    type: "object",
    required: ["dev_uid"],
    properties: {
      dev_uid: { type: "string", minLength: 1 },

    }
  }
};

const uiSchema = {
  dev_uid: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="dev_uid"
          type="text"
          label="UID"
          placeholder="UID"
          textTooltip="Masukkan UID device ini"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }

  },
};

function buildGenConfig(self) {
  const _self = self
  const _props = _self.props
  const domainIsTenant = dit(_props);
  return {
    background_config: {
      [CHECK_DEV_UID]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "service/web/device/provision/ui/check"
        },
        wcallback: {
          started: function (id) {
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              _self.setState({ isDisabled: false });
              _props.wSetConfig(buildCheckConfig(_self));
            }
          }
        },
        wenv: { body: "dev_uid" }
      }
    }
  }
}

function buildCheckConfig(self) {
  const _self = self;
  const _props = safeDeepGet(_self, ['props'])
  const _state = safeDeepGet(_self, ['state'])
  const domainIsTenant = dit(_props);
  _props.wSetEnv({
    type: "body",
    env: "dev_uid",
    value: { "dev_uid": _state.dataToSubmit.dev_uid }
  });
  return {
    single_config: {
      [SUBMIT_DEVICE]: {
        wparam: {
          ...domainIsTenant,
          method: "POST",
          path: "/service/web/device/ui/node/add",
          timeout: 180000
        },
        wcallback: {
          started: function (id) {
          },
          finished: function (id, result) {
            if (result.code === Result.HTTP.OK) {
              let action = setDeviceEmpty();
              store.dispatch(action)
              _props.history.push('..' + S + '..' + S + '_device_list_')
              _props.showSingleNotification({ message: "Sukses" });
            } else {
              _props.showSingleNotification({ message: "Gagal" });
            }
            _self.setState({
              loading: false
            })
          }
        }
      }
    }
  }
}

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      token: '',
      loading: false,
      isDisabled: true
    };
    this.toggle = this.toggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.canSubmit = this.canSubmit.bind(this);
  }

  componentDidMount() {
    // callback global
    setCallbackGlobal(this.props)
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  toggle(tab) {
    const _this = this
    const _state = _this.state
    const { activeTab } = _state
    if (activeTab !== tab) {
      _this.setState({
        activeTab: tab
      });
    }
  }

  myFunction() {
    let x = document.getElementById("myDIV");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
    let y = document.getElementById("divMy");
    if (y.style.display === "none") {
      y.style.display = "block";
    } else {
      y.style.display = "none";
    }
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { isDisabled } = _state
    let storeValue = store.getState();
    let dataToShow = storeValue;
    let dataToSubmit = event.formData;
    let dev_uid = safeDeepGetWithType(event, ['formData', 'dev_uid'], '');
    if (dev_uid === '') {
      _props.showSingleNotification({ message: 'Dev UID tidak boleh kosong', position: 'tr', level: 'error' });
      return;
    }
    dataToSubmit = {
      ...dataToShow.device,
      dev_uid
    }
    let action = setDeviceUSRIotPayload(dataToSubmit);
    _this.setState({
      formData: dataToSubmit
    })
    store.dispatch(action)
    _this.setState({
      ..._state,
      dataToSubmit
    })
    _props.wSetEnv({
      type: "body",
      env: "dev_uid",
      value: { "dev_uid": event.formData['dev_uid'] }
    });
    if (isDisabled) {
      _props.wSetConfig(buildGenConfig(this));
    } else {
      _props.wSingleRequestCall({
        id: SUBMIT_DEVICE,
        body: dataToSubmit
      });
    }
  }

  canSubmit() {
    this.setState({
      isDisabled: false
    })
  }

  goBack() {
    this.props.history.push('..' + S + 'sensors')
  };

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      _this.goBack();
    } else {
      if ('device' in dataToShow) {
        if (isEmpty(dataToShow.device)) {
          _this.goBack();
        } else {
          dataToShow = dataToShow.device;
        }
      } else {
        _this.goBack();
      }
    }
    const { loading, isDisabled } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#ffffff' />
      </div>
    return (
      <Loader show={loading} message={spinner}>
        <div className="view">
          <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat USR IOT baru'
            steps={['Kategori', 'Informasi', 'Aktivasi']} activeStep={2} />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema}
              onSubmit={_this.handleSubmit}
              formData={dataToShow}
            >
              <div className="button-right" style={{ marginTop: 10 }}>
                <Button variant="outlined" size="large" style={{ minWidth: '0%' }} onClick={_props.history.goBack} >Kembali</Button>
                {isDisabled ?
                  <Button variant="outlined" size="large" color="primary" type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}>Aktivasi</Button>
                  :
                  <Button variant="contained" size="large" color="primary" type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                }
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(withRouter(Example));